<template>
  <div style="display: contents">
    <!--    small-->
    <div class="d-block d-sm-none w-100 px-0">
      <div class="menu-group hv-100 pb-4 px-0">
        <!--    <div class="menu-group hv-100 pb-4  fixed-top" position-sticky  sidebar-sticky-->
        <!--         style="top:90px;padding-right: 3px;left: auto;right: auto;max-height:100%">-->
        <div class="group-leftbar pr-1">
          <!-- <my-group-list-item></my-group-list-item> -->
          <ul style="margin-bottom:0">
            <div class="bg-white shadow-sm left-menu py-2 px-1" style="white-space: nowrap; display: block; overflow: auto; padding-inline-start: 0px;">
              <router-link tag="li" :to="'/group/discover'" class="left-bar-title float-left" router-link-exact-active="active">
                <i class="el-icon-discover"></i>
                <!--          群吧-->
                <span class="pl-2">发现</span>
              </router-link>
              <router-link tag="li" :to="'/group/'" class="left-bar-title float-left" router-link-exact-active="active">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50px" height="50px" viewBox="0,0,256,256"><g fill="#626060" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M21.75,0c-0.44531,0.08203 -0.77734,0.45703 -0.8125,0.90625c-0.62109,6.94922 -4.63672,11.53516 -8.71875,16.28125c-4.08203,4.74609 -8.21875,9.70703 -8.21875,17.15625c0,5.10547 2.28516,9.0625 5.28125,11.6875c2.99609,2.625 6.66406,3.96875 9.71875,3.96875c0.35938,0.00391 0.69531,-0.18359 0.87891,-0.49609c0.17969,-0.3125 0.17969,-0.69531 0,-1.00781c-0.18359,-0.3125 -0.51953,-0.5 -0.87891,-0.49609c-2.44531,0 -5.77734,-1.16406 -8.40625,-3.46875c-2.62891,-2.30469 -4.59375,-5.67187 -4.59375,-10.1875c0,-6.71484 3.68359,-11.14453 7.75,-15.875c3.75391,-4.36719 7.70313,-9.05859 8.84375,-15.75c15.14453,10.62109 21.40625,21.41797 21.40625,29.53125c0,7.71094 -4.70703,13.91797 -9.375,15.8125c-0.51953,0.20703 -0.76953,0.79297 -0.5625,1.3125c0.20703,0.51953 0.79297,0.76953 1.3125,0.5625c5.61328,-2.27734 10.625,-9.17578 10.625,-17.6875c0,-9.36719 -7.09375,-20.94141 -23.5,-32.0625c-0.19141,-0.13672 -0.42187,-0.20312 -0.65625,-0.1875c-0.03125,0 -0.0625,0 -0.09375,0zM25.59375,15.40625c-0.27344,0.03125 -0.51953,0.17188 -0.6875,0.39063c-0.16406,0.21875 -0.23047,0.49609 -0.1875,0.76563c0.60938,3.52344 0.75781,6.42188 0.5625,8.59375c-0.19531,2.17188 -0.73828,3.61719 -1.3125,4.28125c-0.57422,0.66406 -1.01172,0.74609 -1.875,0.375c-0.86328,-0.37109 -2.08203,-1.44531 -3.3125,-3.34375c-0.17578,-0.26953 -0.47266,-0.4375 -0.79687,-0.44922c-0.32031,-0.01172 -0.62891,0.13281 -0.82812,0.38672c-3.73047,5.03125 -3.5625,9.05469 -2.25,11.65625c1.3125,2.60156 3.625,3.8125 3.625,3.8125c0.31641,0.22266 0.73047,0.24219 1.07031,0.05469c0.33594,-0.19141 0.53125,-0.55859 0.50391,-0.94531c-0.02734,-0.38672 -0.27734,-0.71875 -0.63672,-0.85937c0,0 -1.78125,-0.95703 -2.78125,-2.9375c-0.90625,-1.80078 -1.14453,-4.5 1.375,-8.4375c1.05469,1.36328 2.11719,2.41797 3.25,2.90625c1.46484,0.62891 3.12891,0.28516 4.15625,-0.90625c1.02734,-1.19141 1.59375,-3.02734 1.8125,-5.4375c0.15234,-1.68359 0.03125,-3.76953 -0.21875,-6.0625c2.70703,2.67578 4.90234,5.55859 5.78125,8.6875c1.10156,3.92188 0.55078,8.07813 -2.65625,12.46875c-0.32812,0.44922 -0.23047,1.07813 0.21875,1.40625c0.44922,0.32813 1.07813,0.23047 1.40625,-0.21875c3.50391,-4.79687 4.22656,-9.72266 2.96875,-14.1875c-1.25781,-4.46484 -4.41406,-8.46484 -8.4375,-11.78125c-0.21094,-0.17187 -0.48047,-0.25 -0.75,-0.21875z"></path></g></g></svg>
                <!--          热门文章-->
                <span class="pl-2">热贴</span>
              </router-link>
              <router-link tag="li" :to="'/group/my'" class="left-bar-title float-left" router-link-exact-active="active"
                           v-if="$store.state.group.groupJoinList.length>0 ||$store.state.group.groupList.length>0  ">
                <div>
                  <i style="font-size: 28px" class="el-icon-document-add"></i>
                  <!--          <i class="el-icon-discover"></i>-->
                  <!--          动态-->
                  <span class="pl-2 align-top">{{ $t('message').group.group_status_title }}</span>
                </div>
              </router-link>
            </div>
            <!--        <button v-if="!$store.state.user.userinfo.id -->
            <!--                class="w-100 my-3 btn btn-outline-secondary"-->
            <!--                type="button"-->
            <!--                @click="$router.push('/login')"-->
            <!--                icon="el-icon-plus">-->
            <!--          + 新建群吧-->
            <!--        </button>-->
            <button href="javascript:void(0)" @click="openDialog(0)"
                    class="w-100  mt-3 btn btn-outline-secondary"
                    type="button"
            >
              <!--            icon="el-icon-plus"-->
              {{ $t('message').group.index_new_btn }}
            </button>

            <div class="mygrouplist">
              <my-group-list-item
                  v-if="isguestgroup"
                  :inputData="$store.state.group.groupInfo"
              ></my-group-list-item>
              <div class="bg-white">
                <!--            我创建的群吧-->
                <div class="cattitle">{{ $t('message').group.my_group_create }}</div>
                <div class="d-flex align-items-center m-2 pb-2"
                     v-if="$store.state.group.groupList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-create.png"
                      shape="square"
                      :size="45">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_create_here }}</span>
                </div>
                <div v-if="$store.state.group.groupList.length!==0 && $store.state.user.userinfo">
                  <my-group-list-item
                      v-for="item in $store.state.group.groupList"
                      :key="item.id"
                      :inputData="item.groupinfo_groupinfoID"
                      :active="activeGroupID===item.groupinfoID"
                  ></my-group-list-item>
                </div>
              </div>
              <!-- create group end-->
            </div>
            <!--       我创建的群吧 end-->
            <!--       我加入的群吧 start-->
            <div class="pb-2">
              <div class="cattitle">{{ $t('message').group.my_group_add }}</div>
              <div class="bg-white">
                <div class="d-flex align-items-center p-2"
                     v-if="$store.state.group.groupJoinList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-added.png"
                      shape="square"
                      :size="40">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_added_here }}</span>
                </div>
              </div>
              <div v-if="$store.state.group.groupJoinList.length!==0 && $store.state.user.userinfo">
                <my-group-list-item
                    v-for="item in $store.state.group.groupJoinList"
                    :key="item.id"
                    :inputData="item.groupinfo_groupinfoID"
                ></my-group-list-item>
              </div>
            </div>
          </ul>
        </div>
      </div>
      <el-dialog width="400px" :title="formTitle" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="" prop="name">
            <el-input
                v-model="form.name"
                autocomplete="off"
                maxlength="20"
                show-word-limit
                class="rounded"
                placeholder="请输入群吧名称(必填)">
            </el-input>
          </el-form-item>
          <!--              群吧描述-->
          <el-form-item class="mb-4 pb-1" label="" prop="description">
            <el-input
                class="flex-fill mr-2"
                type="textarea"
                :rows="3"
                show-word-limit
                placeholder="请输入群吧主题"
                v-model="form.description">
              <!--                maxlength="100"-->

            </el-input>
          </el-form-item>
          <!--              公开/私有-->
          <el-tooltip content="任何人都能查看群吧帖" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="0">{{ $t('message').group.group_is_open }}</el-radio>
          </el-tooltip>
          <el-tooltip content="只有成员才能查看群吧帖。" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="1">{{ $t('message').group.group_is_private }}</el-radio>
          </el-tooltip>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <button class="btn btn-simple px-3 py-2" @click="dialogFormVisible = false">{{
              $t('message').editor.wenji_new_cancel
            }}
          </button>
          <el-popconfirm
              :width="370"
              :height="300"
              :padding="20"
              icon="el-icon-message-solid"
              icon-color="#ffab32"
              placement="top-end"
              class="shadow-lg"
              confirm-button-text='确认'
              cancel-button-text='取消'
              title="为了保护群吧成员的隐私，群吧创建后公开或非公开状态一旦设定无法更改"
              @confirm="addGroup"
          >
            <!--                @click="dialogFormVisible = false"-->
            <button slot="reference" class="btn btn-primary px-3 py-2 ml-3">
              {{ $t('message').editor.wenji_new_ok }}
            </button>
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>
    <!--    normal-->
    <div class="col-sm-3 d-none d-sm-inline menu-group px-0">
      <right-footer></right-footer>
      <div class="menu-group hv-100 pb-4">
        <!--    <div class="menu-group hv-100 pb-4  fixed-top" position-sticky  sidebar-sticky-->
        <!--         style="top:90px;padding-right: 3px;left: auto;right: auto;max-height:100%">-->
        <div class="group-leftbar pr-1">
          <!-- <my-group-list-item></my-group-list-item> -->
          <ul style="margin-bottom:0">
            <div class="bg-white shadow-sm left-menu">
              <router-link tag="li" :to="'/group/'" class="left-bar-title" router-link-exact-active="active">
                <i class="el-icon-discover"></i>
                <!--          群吧-->
                <span class="pl-2">{{ $t('message').group.index_discover }}</span>
              </router-link>
              <hr class="my-0" style="border-color: #eee">
              <router-link tag="li" :to="'/group/discover'" class="left-bar-title" router-link-exact-active="active">
                <i class="el-icon-document-copy medium"></i>
                <!--          热门文章-->
                <span class="pl-2">{{ $t('message').group.index_article_hot }}</span>
              </router-link>

              <hr class="my-0" style="border-color: #eee">
              <router-link tag="li" :to="'/group/my'" class="left-bar-title" router-link-exact-active="active"
                           v-if="$store.state.group.groupJoinList.length>0 || $store.state.group.groupList.length>0">
                <el-popover
                    placement="right"
                    trigger="hover"
                    effect="light">
                  <div class="align-middle">
                    <div><span>{{ $t('message').group.group_status_explain }}</span></div>
                  </div>
                  <div slot="reference">
                    <i style="font-size: 28px" class="el-icon-document-add"></i>
                    <!--          <i class="el-icon-discover"></i>-->
                    <!--          动态-->
                    <span class="pl-2 align-top">{{ $t('message').group.group_status_title }}</span>
                  </div>
                </el-popover>
              </router-link>
            </div>
            <!--        <button v-if="!$store.state.user.userinfo.id -->
            <!--                class="w-100 my-3 btn btn-outline-secondary"-->
            <!--                type="button"-->
            <!--                @click="$router.push('/login')"-->
            <!--                icon="el-icon-plus">-->
            <!--          + 新建群吧-->
            <!--        </button>-->
            <button href="javascript:void(0)" @click="openDialog(0)"
                    class="w-100  mt-3 btn btn-outline-secondary"
                    type="button"
            >
              <!--            icon="el-icon-plus"-->
              {{ $t('message').group.index_new_btn }}
            </button>

            <div class="mygrouplist">
              <my-group-list-item
                  v-if="isguestgroup"
                  :inputData="$store.state.group.groupInfo"
              ></my-group-list-item>
              <div class="bg-white">
                <!--            我创建的群吧-->
                <div class="cattitle">{{ $t('message').group.my_group_create }}</div>
                <div class="d-flex align-items-center m-2 pb-2"
                     v-if="$store.state.group.groupList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-create.png"
                      shape="square"
                      :size="45">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_create_here }}</span>
                </div>
                <div v-if="$store.state.group.groupList.length!==0 && $store.state.user.userinfo">
                  <my-group-list-item
                      v-for="item in $store.state.group.groupList"
                      :key="item.id"
                      :inputData="item.groupinfo_groupinfoID"
                      :active="activeGroupID===item.groupinfoID"
                  ></my-group-list-item>
                </div>
              </div>
              <!-- create group end-->
            </div>
            <!--       我创建的群吧 end-->
            <!--       我加入的群吧 start-->
            <div class="pb-2">
              <div class="cattitle">{{ $t('message').group.my_group_add }}</div>
              <div class="bg-white">
                <div class="d-flex align-items-center p-2"
                     v-if="$store.state.group.groupJoinList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-added.png"
                      shape="square"
                      :size="40">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_added_here }}</span>
                </div>
              </div>
              <div v-if="$store.state.group.groupJoinList.length!==0 && $store.state.user.userinfo">
                <my-group-list-item
                    v-for="item in $store.state.group.groupJoinList"
                    :key="item.id"
                    :inputData="item.groupinfo_groupinfoID"
                ></my-group-list-item>
              </div>
            </div>
          </ul>

          <group-help></group-help>
          <!--      <login-encourage></login-encourage>-->
          <!--    <login-dialog ref="dialog"></login-dialog>-->
        </div>
      </div>
      <el-dialog width="400px" :title="formTitle" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="" prop="name">
            <el-input
                v-model="form.name"
                autocomplete="off"
                maxlength="20"
                show-word-limit
                class="rounded"
                placeholder="请输入群吧名称(必填)">
            </el-input>
          </el-form-item>
          <!--              群吧描述-->
          <el-form-item class="mb-4 pb-1" label="" prop="description">
            <el-input
                class="flex-fill mr-2"
                type="textarea"
                :rows="3"
                show-word-limit
                placeholder="请输入群吧主题"
                v-model="form.description">
            </el-input>
          </el-form-item>
          <!--              公开/私有-->
          <el-tooltip content="任何人都能查看群吧帖" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="0">{{ $t('message').group.group_is_open }}</el-radio>
          </el-tooltip>
          <el-tooltip content="只有成员才能查看群吧帖。" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="1">{{ $t('message').group.group_is_private }}</el-radio>
          </el-tooltip>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <button class="btn btn-simple px-3 py-2" @click="dialogFormVisible = false">{{
              $t('message').editor.wenji_new_cancel
            }}
          </button>
          <el-popconfirm
              :width="370"
              :height="300"
              :padding="20"
              icon="el-icon-message-solid"
              icon-color="#ffab32"
              placement="top-end"
              class="shadow-lg"
              confirm-button-text='确认'
              cancel-button-text='取消'
              title="为了保护群吧成员的隐私，群吧创建后公开或非公开状态一旦设定无法更改"
              @confirm="addGroup"
          >
            <!--                @click="dialogFormVisible = false"-->
            <button slot="reference" class="btn btn-primary px-3 py-2 ml-3">
              {{ $t('message').editor.wenji_new_ok }}
            </button>
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>
    <!--    normal end-->
  </div>
</template>
<script>
import {Avatar, Button, Dialog, Menu, MenuItem, Radio, Submenu, Popconfirm, Popover} from 'element-ui';
import group from '../../group.service';
import MyGroupListItem from '../../pages/components/group/MyGroupListItem.vue';
// import LoginEncourage  from '@/module/user/components/LoginEncourage.vue';
import GroupHelp from '@/module/group/pages/components/Main/GroupHelp.vue';
import RightFooter from '@/layout/RightFooter.vue';
// import LoginDialog from '@/module/user/login/LoginDialog';

export default {
  name: 'left-bar',
  props: {
    activeGroupID: Number
  },
  components: {
    // MainMenu,
    // ArticleListItem,
    // Avatar,
    // IndexHeader,
    // GroupCardItem,
    // RegisterGroupListItem,
    MyGroupListItem,
    RightFooter,
    GroupHelp,
    // LoginEncourage,
    // LoginDialog,
    [Menu.name]: Avatar,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Submenu.name]: Submenu,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Popconfirm.name]: Popconfirm,
    [Popover.name]: Popover
  },
  watch: {},
  mounted: function () {
  },
  created: function () {
    if (this.$store.state.user.userinfo) {
      this.$store.dispatch('group/GetGroupList');
      this.$store.dispatch('group/GetGroupJoinList');
    }
  },
  computed: {
    disabled() {
      return this.loading.article || this.noMore;
    },
    isguestgroup() {
      return !this.$store.getters['group/isMygroup'];
    }
  },
  methods: {
    changeID(id) { // for msite
      if (id > 0) {
        this.selectItem = this.joinedgroupList[id - 1]
      } else {
        this.selectItem = {groupinfoID: id};
        this.selectID = id;
      }
    },
    changeTab(id) {
      this.currentTabId = id;
      this.lastID.article = 0;
    },

    selected(item) {
      this.selectItem = item;
      this.lastID.article = 0;
      this.articlelists = [];
      item.groupinfoID >= 0 ? this.getArticleList() : '';
      this.header_info(item.groupinfoID);
    },
    // 我加入的群吧
    getJoining() {
      group.group_join_list(0).then(res => {
        if (res.status) {
          this.joinedgroupList = res.data;
          this.selectItem.groupinfoID = this.joinedgroupList.length > 0 ? 0 : -1;
          this.getArticleList();
        }
      });
    },
    header_info(groupID) {
      if (groupID > 0) {
        group.get_user_info(groupID).then(res => {
          this.userinfo = res.data;
        });
      } else {
        this.userinfo.id = groupID
      }
    },

    // async getGroup(id)
    // {
    //   let arr = await group.recommand_group(this.lastID.article);
    //   this.hotGroups = arr.data;
    // },

    getList(res) {
      if (res.status) {
        let arr = res.data.filter(obj => obj.visible != 0);
        ;
        this.noMore = arr.length < 30 ? true : false;
        this.lastID.article = arr.length === 30 ? arr[arr.length - 1].create_date : this.lastID.article;
        if (this.lastID.article == 0) {
          this.articleList = [];
        }
        this.articleList = this.articleList.concat(arr);
        this.loading.article = false;
        this.articleList.forEach(item => {
          if (item.postInfo_postID.title == "") {
            item.postInfo_postID.title = this.$t('message').editor.title_ph
          }
        })
      }
    },
    // updateCategory(item){
    //   this.$refs['form'].validate((valid) => {
    //     if (valid) {
    //       this.btnDisable = true;
    //       group.group_update(item.id,this.field.name,this.form.value).then(res=>{
    //       // group.group_update(this.form.name,this.form.is_private,item.id).then(res=>{
    //         if(res.status){
    //           this.getCategories();
    //         }
    //       })
    //     }
    //   })
    // },

    openDialog(item) {
      console
      if (!this.check_user_login()) return;
      this.item = item
      this.formTitle = item ? this.$t('message').editor.group_setting_title : this.$t('message').editor.group_new_title;
      this.form.name = item ? item.name : ''
      this.form.description = item ? item.description : ''
      this.form.is_private = item ? item.is_private : 1
      this.dialogFormVisible = true

    },

    //添加群吧
    addGroup() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnDisable = true;
          //创建群吧
          group.group_register(this.form.name, this.form.description, this.form.is_private).then(res => {
            if (res.status) {
              //获取我创建的群吧
              this.$store.dispatch('group/GetGroupList');
              this.$router.push('/group/index/' + res.data)
            } else {
              console.log(res.data)
            }
          })
          this.dialogFormVisible = false;
        }
      })
    },
  },
  data() {
    var checkNameSame = (rule, value, callback) => {
      if (this.item == 0) {
        this.creategroupList.forEach(item => {
          if (item.name === value) {
            return callback(new Error(this.$t('message').editor.group_new_error))
          }
        })
      }
      callback()
    }
    var checkDesSame = (rule, value, callback) => {
      if (this.item == 0) {
        this.creategroupList.forEach(item => {
          if (item.description === value) {
            return callback(new Error(this.$t('message').editor.group_new_error))
          }
        })
      }
      callback()
    }
    return {
      topicID: [],
      user: this.$store.state.user,
      userinfo: {},
      groupInfo: {},
      selectItem: {groupinfoID: -1},
      joinedgroupList: [],
      articlelists: [],
      hotGroups: [],
      loading: {article: true, blogger: true},
      lastID: {article: 0, blogger: 0},
      noMore: false,
      selectID: 0,
      dialogFormVisible: false,
      btnDisable: false,
      formTitle: '',
      item: 0,
      shiftable: true,
      form: {
        name: '',
        description: '',
        is_private: 1
      },
      rules: {
        name: [
          {required: true, message: '请输入群吧名称', trigger: 'blur'},
          {validator: checkNameSame, trigger: 'blur'}],
        description: [
          {required: true, message: '请输入群吧主题', trigger: 'blur'},
          {validator: checkDesSame, trigger: 'blur'}]
      },
      show_setting: false,
      authorInfo: {},
      creategroupList: [],
      joingrouplist: [],
      // groupinfoID: 0,
      length: 0,
      collectionList: [],
    };
  },
  filters: {
    formatDate(time) {
      var date = new Date(time)
      ;
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
};


</script><template>
  <div style="display: contents">
    <!--    small-->
    <div class="d-block d-sm-none w-100 px-0">
      <div class="menu-group hv-100 pb-4 px-0">
        <!--    <div class="menu-group hv-100 pb-4  fixed-top" position-sticky  sidebar-sticky-->
        <!--         style="top:90px;padding-right: 3px;left: auto;right: auto;max-height:100%">-->
        <div class="group-leftbar pr-1">
          <!-- <my-group-list-item></my-group-list-item> -->
          <ul style="margin-bottom:0">
            <div class="bg-white shadow-sm left-menu py-2 px-1" style="white-space: nowrap; display: block; overflow: auto; padding-inline-start: 0px;">
              <router-link tag="li" :to="'/group/new'" class="left-bar-title float-left" router-link-exact-active="active">
                <i class="el-icon-discover"></i>
                <!--          群吧-->
                <span class="pl-2">发现</span>
              </router-link>
              <router-link tag="li" :to="'/group/discover'" class="left-bar-title float-left" router-link-exact-active="active">
                <i class="el-icon-discover"></i>
                <!--          群吧-->
                <span class="pl-2">热门</span>
              </router-link>
              <router-link tag="li" :to="'/group/'" class="left-bar-title float-left" router-link-exact-active="active">
                <i class="el-icon-document-copy medium"></i>
                <!--          热门文章-->
                <span class="pl-2">热贴</span>
              </router-link>
              <router-link tag="li" :to="'/group/my'" class="left-bar-title float-left" router-link-exact-active="active"
                           v-if="$store.state.group.groupJoinList.length>0 ||$store.state.group.groupList.length>0  ">
                <div>
                  <i style="font-size: 28px" class="el-icon-document-add"></i>
                  <!--          <i class="el-icon-discover"></i>-->
                  <!--          动态-->
                  <span class="pl-2 align-top">{{ $t('message').group.group_status_title }}</span>
                </div>
              </router-link>
            </div>
            <!--        <button v-if="!$store.state.user.userinfo.id -->
            <!--                class="w-100 my-3 btn btn-outline-secondary"-->
            <!--                type="button"-->
            <!--                @click="$router.push('/login')"-->
            <!--                icon="el-icon-plus">-->
            <!--          + 新建群吧-->
            <!--        </button>-->
            <button href="javascript:void(0)" @click="openDialog(0)"
                    class="w-100  mt-3 btn btn-outline-secondary"
                    type="button"
            >
              <!--            icon="el-icon-plus"-->
              {{ $t('message').group.index_new_btn }}
            </button>

            <div class="mygrouplist">
              <my-group-list-item
                  v-if="isguestgroup"
                  :inputData="$store.state.group.groupInfo"
              ></my-group-list-item>
              <div class="bg-white">
                <!--            我创建的群吧-->
                <div class="cattitle">{{ $t('message').group.my_group_create }}</div>
                <div class="d-flex align-items-center m-2 pb-2"
                     v-if="$store.state.group.groupList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-create.png"
                      shape="square"
                      :size="45">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_create_here }}</span>
                </div>
                <div v-if="$store.state.group.groupList.length!==0 && $store.state.user.userinfo">
                  <my-group-list-item
                      v-for="item in $store.state.group.groupList"
                      :key="item.id"
                      :inputData="item.groupinfo_groupinfoID"
                      :active="activeGroupID===item.groupinfoID"
                  ></my-group-list-item>
                </div>
              </div>
              <!-- create group end-->
            </div>
            <!--       我创建的群吧 end-->
            <!--       我加入的群吧 start-->
            <div class="pb-2">
              <div class="cattitle">{{ $t('message').group.my_group_add }}</div>
              <div class="bg-white">
                <div class="d-flex align-items-center p-2"
                     v-if="$store.state.group.groupJoinList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-added.png"
                      shape="square"
                      :size="40">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_added_here }}</span>
                </div>
              </div>
              <div v-if="$store.state.group.groupJoinList.length!==0 && $store.state.user.userinfo">
                <my-group-list-item
                    v-for="item in $store.state.group.groupJoinList"
                    :key="item.id"
                    :inputData="item.groupinfo_groupinfoID"
                ></my-group-list-item>
              </div>
            </div>
          </ul>
          <!--        <group-help></group-help>-->
          <!--      <login-encourage></login-encourage>-->
          <!--        <right-footer></right-footer>-->
          <!--    <login-dialog ref="dialog"></login-dialog>-->
        </div>
      </div>
      <el-dialog width="400px" :title="formTitle" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="" prop="name">
            <el-input
                v-model="form.name"
                autocomplete="off"
                maxlength="20"
                show-word-limit
                class="rounded"
                placeholder="请输入群吧名称(必填)">
            </el-input>
          </el-form-item>
          <!--              群吧描述-->
          <el-form-item class="mb-4 pb-1" label="" prop="description">
            <el-input
                class="flex-fill mr-2"
                type="textarea"
                :rows="3"
                show-word-limit
                placeholder="请输入群吧主题"
                v-model="form.description">
            </el-input>
          </el-form-item>
          <!--              公开/私有-->
          <el-tooltip content="任何人都能查看群吧帖" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="0">{{ $t('message').group.group_is_open }}</el-radio>
          </el-tooltip>
          <el-tooltip content="只有成员才能查看群吧帖。" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="1">{{ $t('message').group.group_is_private }}</el-radio>
          </el-tooltip>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <button class="btn btn-simple px-3 py-2" @click="dialogFormVisible = false">{{
              $t('message').editor.wenji_new_cancel
            }}
          </button>
          <el-popconfirm
              :width="370"
              :height="300"
              :padding="20"
              icon="el-icon-message-solid"
              icon-color="#ffab32"
              placement="top-end"
              class="shadow-lg"
              confirm-button-text='确认'
              cancel-button-text='取消'
              title="为了保护群吧成员的隐私，群吧创建后公开或非公开状态一旦设定无法更改"
              @confirm="addGroup"
          >
            <!--                @click="dialogFormVisible = false"-->
            <button slot="reference" class="btn btn-primary px-3 py-2 ml-3">
              {{ $t('message').editor.wenji_new_ok }}
            </button>
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>
    <!--    normal-->
    <div class="col-sm-3 d-none d-sm-inline menu-group px-0" style="top: 5px">
      <div class="menu-group hv-100 pb-4">
        <!--    <div class="menu-group hv-100 pb-4  fixed-top" position-sticky  sidebar-sticky-->
        <!--         style="top:90px;padding-right: 3px;left: auto;right: auto;max-height:100%">-->
        <div class="group-leftbar pr-1">
<!--          <nav-link to="/backend" v-if="$store.state.user.userinfo.UserLevel==2">-->
<!--            <i class="icon" v-html="icons.setting" style="top:-1px"></i> {{ $t('message').topnav.admin }}-->
<!--          </nav-link>-->

          <div v-if="$store.state.user.check_is_wxc_domain() && $store.state.user.userinfo.UserLevel==6" class="bg-white shadow-sm left-menu mb-3">
            <router-link tag="li" :to="'/wxcbackend'" class="left-bar-title" router-link-exact-active="active">
              <span class="pl-2 text-black">管理员审核</span>
            </router-link>
            <hr class="my-0" style="border-color: #eee">
          </div>
          <!-- <my-group-list-item></my-group-list-item> -->
          <ul style="margin-bottom:0">
            <div class="bg-white shadow-sm left-menu">
              <router-link tag="li" :to="'/group/new'" class="left-bar-title" router-link-exact-active="active">
                <i class="el-icon-discover"></i>
                <!--          群吧-->
                <span class="pl-2">{{ $t('message').group.index_discover }}</span>
              </router-link>
              <router-link tag="li" :to="'/group/'" class="left-bar-title" router-link-exact-active="active">
<!--                <i class="el-icon-view"></i>-->
                <!--          群吧-->
                <svg style="font-size: 10px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="27px" height="27px" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="currentColor" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M21.75,0c-0.44531,0.08203 -0.77734,0.45703 -0.8125,0.90625c-0.62109,6.94922 -4.63672,11.53516 -8.71875,16.28125c-4.08203,4.74609 -8.21875,9.70703 -8.21875,17.15625c0,5.10547 2.28516,9.0625 5.28125,11.6875c2.99609,2.625 6.66406,3.96875 9.71875,3.96875c0.35938,0.00391 0.69531,-0.18359 0.87891,-0.49609c0.17969,-0.3125 0.17969,-0.69531 0,-1.00781c-0.18359,-0.3125 -0.51953,-0.5 -0.87891,-0.49609c-2.44531,0 -5.77734,-1.16406 -8.40625,-3.46875c-2.62891,-2.30469 -4.59375,-5.67187 -4.59375,-10.1875c0,-6.71484 3.68359,-11.14453 7.75,-15.875c3.75391,-4.36719 7.70313,-9.05859 8.84375,-15.75c15.14453,10.62109 21.40625,21.41797 21.40625,29.53125c0,7.71094 -4.70703,13.91797 -9.375,15.8125c-0.51953,0.20703 -0.76953,0.79297 -0.5625,1.3125c0.20703,0.51953 0.79297,0.76953 1.3125,0.5625c5.61328,-2.27734 10.625,-9.17578 10.625,-17.6875c0,-9.36719 -7.09375,-20.94141 -23.5,-32.0625c-0.19141,-0.13672 -0.42187,-0.20312 -0.65625,-0.1875c-0.03125,0 -0.0625,0 -0.09375,0zM25.59375,15.40625c-0.27344,0.03125 -0.51953,0.17188 -0.6875,0.39063c-0.16406,0.21875 -0.23047,0.49609 -0.1875,0.76563c0.60938,3.52344 0.75781,6.42188 0.5625,8.59375c-0.19531,2.17188 -0.73828,3.61719 -1.3125,4.28125c-0.57422,0.66406 -1.01172,0.74609 -1.875,0.375c-0.86328,-0.37109 -2.08203,-1.44531 -3.3125,-3.34375c-0.17578,-0.26953 -0.47266,-0.4375 -0.79687,-0.44922c-0.32031,-0.01172 -0.62891,0.13281 -0.82812,0.38672c-3.73047,5.03125 -3.5625,9.05469 -2.25,11.65625c1.3125,2.60156 3.625,3.8125 3.625,3.8125c0.31641,0.22266 0.73047,0.24219 1.07031,0.05469c0.33594,-0.19141 0.53125,-0.55859 0.50391,-0.94531c-0.02734,-0.38672 -0.27734,-0.71875 -0.63672,-0.85937c0,0 -1.78125,-0.95703 -2.78125,-2.9375c-0.90625,-1.80078 -1.14453,-4.5 1.375,-8.4375c1.05469,1.36328 2.11719,2.41797 3.25,2.90625c1.46484,0.62891 3.12891,0.28516 4.15625,-0.90625c1.02734,-1.19141 1.59375,-3.02734 1.8125,-5.4375c0.15234,-1.68359 0.03125,-3.76953 -0.21875,-6.0625c2.70703,2.67578 4.90234,5.55859 5.78125,8.6875c1.10156,3.92188 0.55078,8.07813 -2.65625,12.46875c-0.32812,0.44922 -0.23047,1.07813 0.21875,1.40625c0.44922,0.32813 1.07813,0.23047 1.40625,-0.21875c3.50391,-4.79687 4.22656,-9.72266 2.96875,-14.1875c-1.25781,-4.46484 -4.41406,-8.46484 -8.4375,-11.78125c-0.21094,-0.17187 -0.48047,-0.25 -0.75,-0.21875z"></path></g></g></svg>
                <span class="pl-2">热门群吧</span>
              </router-link>
              <hr class="my-0" style="border-color: #eee">
              <router-link tag="li" :to="'/group/discover'" class="left-bar-title" router-link-exact-active="active">
                <i class="el-icon-document-copy medium"></i>
                <!--          热门文章-->
                <span class="pl-2">{{ $t('message').group.index_article_hot }}</span>
              </router-link>
              <hr class="my-0" style="border-color: #eee">
              <router-link tag="li" :to="'/group/my'" class="left-bar-title" router-link-exact-active="active"
                           v-if="$store.state.group.groupJoinList.length>0 ||$store.state.group.groupList.length>0  ">
                <el-popover
                    placement="right"
                    trigger="hover"
                    effect="light">
                  <div class="align-middle">
                    <div><span>{{ $t('message').group.group_status_explain }}</span></div>
                  </div>
                  <div slot="reference">
                    <i style="font-size: 28px" class="el-icon-document-add"></i>
                    <!--          <i class="el-icon-discover"></i>-->
                    <!--          动态-->
                    <span class="pl-2 align-top">{{ $t('message').group.group_status_title }}</span>
                  </div>
                </el-popover>
              </router-link>
            </div>
            <!--        <button v-if="!$store.state.user.userinfo.id -->
            <!--                class="w-100 my-3 btn btn-outline-secondary"-->
            <!--                type="button"-->
            <!--                @click="$router.push('/login')"-->
            <!--                icon="el-icon-plus">-->
            <!--          + 新建群吧-->
            <!--        </button>-->
            <button href="javascript:void(0)" @click="openDialog(0)"
                    class="w-100  mt-3 btn btn-outline-secondary"
                    type="button"
            >
              <!--            icon="el-icon-plus"-->
              {{ $t('message').group.index_new_btn }}
            </button>

            <div class="mygrouplist">
              <my-group-list-item
                  v-if="isguestgroup"
                  :inputData="$store.state.group.groupInfo"
              ></my-group-list-item>
              <div class="bg-white">
                <!--            我创建的群吧-->
                <div class="cattitle">{{ $t('message').group.my_group_create }}</div>
                <div class="d-flex align-items-center m-2 pb-2"
                     v-if="$store.state.group.groupList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-create.png"
                      shape="square"
                      :size="45">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_create_here }}</span>
                </div>
                <div v-if="$store.state.group.groupList.length!==0 && $store.state.user.userinfo">
                  <my-group-list-item
                      v-for="item in $store.state.group.groupList"
                      :key="item.id"
                      :inputData="item.groupinfo_groupinfoID"
                      :active="activeGroupID===item.groupinfoID"
                  ></my-group-list-item>
                </div>
              </div>
              <!-- create group end-->
            </div>
            <!--       我创建的群吧 end-->
            <!--       我加入的群吧 start-->
            <div class="pb-2">
              <div class="cattitle">{{ $t('message').group.my_group_add }}</div>
              <div class="bg-white">
                <div class="d-flex align-items-center p-2"
                     v-if="$store.state.group.groupJoinList.length===0 || !$store.state.user.userinfo">
                  <el-avatar
                      src="/img/group-added.png"
                      shape="square"
                      :size="40">
                  </el-avatar>
                  <span class="ml-2 text-secondary">{{ $t('message').group.group_added_here }}</span>
                </div>
              </div>
              <div v-if="$store.state.group.groupJoinList.length!==0 && $store.state.user.userinfo">
                <my-group-list-item
                    v-for="item in $store.state.group.groupJoinList"
                    :key="item.id"
                    :inputData="item.groupinfo_groupinfoID"
                ></my-group-list-item>
              </div>
            </div>
          </ul>

          <group-help></group-help>
          <right-footer class="mt-4"></right-footer>
          <!--      <login-encourage></login-encourage>-->
          <!--    <login-dialog ref="dialog"></login-dialog>-->
        </div>
      </div>
      <el-dialog width="400px" :title="formTitle" :visible.sync="dialogFormVisible">
<!--        <el-select v-model="curentArticle.categoryID" placeholder="请选择" @change="changeCategory">-->
        <el-form :model="form" :rules="rules" ref="form">
          <span style="line-height: 39px">请选择群吧分类</span>
          <el-select  v-model="form.tagID" class="mb-3 float-right" placeholder="请选择群组分类" @change="changeTag">
            <el-option
                v-for="item in TagList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <el-form-item label="" prop="name">
            <el-input
                v-model="form.name"
                type="textarea"
                autocomplete="off"
                maxlength="20"
                show-word-limit
                class="rounded"
                placeholder="请输入群吧名称(必填)">
            </el-input>
          </el-form-item>
          <!--              群吧描述-->
          <el-form-item class="mb-4 pb-1" label="" prop="description">
            <el-input
                class="flex-fill mr-2"
                type="textarea"
                :rows="3"
                show-word-limit
                placeholder="请输入群吧主题(必填)"
                v-model="form.description">
            </el-input>
          </el-form-item>
          <!--              公开/私有-->
          <el-tooltip content="任何人都能查看群吧帖" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="0">{{ $t('message').group.group_is_open }}</el-radio>
          </el-tooltip>
          <el-tooltip content="只有成员才能查看群吧帖。" placement="bottom" effect="light">
            <el-radio v-model="form.is_private" :label="1">{{ $t('message').group.group_is_private }}</el-radio>
          </el-tooltip>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <button class="btn btn-simple px-3 py-2" @click="dialogFormVisible = false">{{
              $t('message').editor.wenji_new_cancel
            }}
          </button>
          <el-popconfirm
              :width="370"
              :height="300"
              :padding="20"
              icon="el-icon-message-solid"
              icon-color="#ffab32"
              placement="top-end"
              class="shadow-lg"
              confirm-button-text='确认'
              cancel-button-text='取消'
              title="为了保护群吧成员的隐私，群吧创建后公开或非公开状态一旦设定无法更改"
              @confirm="addGroup"
          >
            <!--                @click="dialogFormVisible = false"-->
            <button slot="reference" class="btn btn-primary px-3 py-2 ml-3">
              {{ $t('message').editor.wenji_new_ok }}
            </button>
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>
    <!--    normal end-->
  </div>
</template>
<script>
import {Avatar, Button, Dialog, Menu, MenuItem, Radio, Submenu, Popconfirm, Popover} from 'element-ui';
import group from '@/module/group/group.service';
import MyGroupListItem from '../../pages/components/group/MyGroupListItem.vue';
// import LoginEncourage  from '@/module/user/components/LoginEncourage.vue';
import GroupHelp from '@/module/group/pages/components/Main/GroupHelp.vue';
import RightFooter from '@/layout/RightFooter.vue';
// import LoginDialog from '@/module/user/login/LoginDialog';

export default {
  name: 'left-bar',
  props: {
    activeGroupID: Number
  },
  components: {
    // MainMenu,
    // ArticleListItem,
    // Avatar,
    // IndexHeader,
    // GroupCardItem,
    // RegisterGroupListItem,
    MyGroupListItem,
    RightFooter,
    GroupHelp,
    // LoginEncourage,
    // LoginDialog,
    [Menu.name]: Avatar,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Submenu.name]: Submenu,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Popconfirm.name]: Popconfirm,
    [Popover.name]: Popover
  },
  watch: {},
  mounted: function () {
  },
  created: function () {
    group.group_tag().then(res=>{
      if (res.status) {
        this.TagList = res.data;
        // this.TagList.id = this.TagList[2].id;
      }
    });
    if (this.$store.state.user.userinfo) {
      this.$store.dispatch('group/GetGroupList');
      this.$store.dispatch('group/GetGroupJoinList');
    }
  },
  computed: {
    disabled() {
      return this.loading.article || this.noMore;
    },
    isguestgroup() {
      return !this.$store.getters['group/isMygroup'];
    }
  },
  methods: {
    changeID(id) { // for msite
      if (id > 0) {
        this.selectItem = this.joinedgroupList[id - 1]
      } else {
        this.selectItem = {groupinfoID: id};
        this.selectID = id;
      }
    },
    changeTab(id) {
      this.currentTabId = id;
      this.lastID.article = 0;
    },

    selected(item) {
      this.selectItem = item;
      this.lastID.article = 0;
      this.articlelists = [];
      item.groupinfoID >= 0 ? this.getArticleList() : '';
      this.header_info(item.groupinfoID);
    },
    // 我加入的群吧
    getJoining() {
      group.group_join_list(0).then(res => {
        if (res.status) {
          this.joinedgroupList = res.data;
          this.selectItem.groupinfoID = this.joinedgroupList.length > 0 ? 0 : -1;
          this.getArticleList();
        }
      });
    },
    changeTag() {
      group.group_tag().then(res=>{
        if (res.status) {
          this.TagList = res.data;
        }
      });
    },

    header_info(groupID) {
      if (groupID > 0) {
        group.get_user_info(groupID).then(res => {
          this.userinfo = res.data;
        });
      } else {
        this.userinfo.id = groupID
      }
    },

    // async getGroup(id)
    // {
    //   let arr = await group.recommand_group(this.lastID.article);
    //   this.hotGroups = arr.data;
    // },

    getList(res) {
      if (res.status) {
        let arr = res.data.filter(obj => obj.visible != 0);
        ;
        this.noMore = arr.length < 30 ? true : false;
        this.lastID.article = arr.length === 30 ? arr[arr.length - 1].create_date : this.lastID.article;
        if (this.lastID.article == 0) {
          this.articleList = [];
        }
        this.articleList = this.articleList.concat(arr);
        this.loading.article = false;
        this.articleList.forEach(item => {
          if (item.postInfo_postID.title == "") {
            item.postInfo_postID.title = this.$t('message').editor.title_ph
          }
        })
      }
    },
    // updateCategory(item){
    //   this.$refs['form'].validate((valid) => {
    //     if (valid) {
    //       this.btnDisable = true;
    //       group.group_update(item.id,this.field.name,this.form.value).then(res=>{
    //       // group.group_update(this.form.name,this.form.is_private,item.id).then(res=>{
    //         if(res.status){
    //           this.getCategories();
    //         }
    //       })
    //     }
    //   })
    // },

    openDialog(item) {
      if (!this.check_user_login()) return;
      this.item = item
      this.formTitle = item ? this.$t('message').editor.group_setting_title : this.$t('message').editor.group_new_title;
      this.form.name = item ? item.name : ''
      this.form.description = item ? item.description : ''
      this.form.is_private = item ? item.is_private : 1
      this.dialogFormVisible = true
    },

    //添加群吧
    addGroup() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnDisable = true;
          //创建群吧
          group.group_register(this.form.name, this.form.tagID,this.form.description, this.form.is_private).then(res => {
            if (res.status) {
              //获取我创建的群吧
              this.$store.dispatch('group/GetGroupList');
              this.$router.push('/group/index/' + res.data);
              this.$message.success('群吧创建成功!');
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res.error);
              console.log(res.data)
            }
          })


        }
      })
    },

  },
  data() {
    var checkNameSame = (rule, value, callback) => {
      if (this.item == 0) {
        this.creategroupList.forEach(item => {
          if (item.name === value) {
            return callback(new Error(this.$t('message').editor.group_new_error))
          }
        })
      }
      callback()
    }
    var checkDesSame = (rule, value, callback) => {
      if (this.item == 0) {
        this.creategroupList.forEach(item => {
          if (item.description === value) {
            return callback(new Error(this.$t('message').editor.group_new_error))
          }
        })
      }
      callback()
    }
    return {
      topicID: [],
      user: this.$store.state.user,
      userinfo: {},
      groupInfo: {},
      selectItem: {groupinfoID: -1},
      joinedgroupList: [],
      articlelists: [],
      hotGroups: [],
      loading: {article: true, blogger: true},
      lastID: {article: 0, blogger: 0},
      noMore: false,
      selectID: 0,
      dialogFormVisible: false,
      btnDisable: false,
      formTitle: '',
      value:[],
      item: 0,
      shiftable: true,
      form: {
        name: '',
        description: '',
        is_private: 1,
        tagID: 10014,
        value: 'item.id',
      },
      rules: {
        name: [
          {required: true, message: '请输入群吧名称', trigger: 'blur'},
          {validator: checkNameSame, trigger: 'blur'}],
        description: [
          {required: true, message: '请输入群吧主题', trigger: 'blur'},
          {validator: checkDesSame, trigger: 'blur'}]
      },
      show_setting: false,
      authorInfo: {},
      creategroupList: [],
      joingrouplist: [],
      // groupinfoID: 0,
      length: 0,
      TagList: [],
    };
  },
  filters: {
    formatDate(time) {
      var date = new Date(time)
      ;
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
};


</script>
<style>
#WxcColor .group-leftbar .mygrouplist{
  margin:0
}
.group-leftbar .mygrouplist{
  margin:0 5px
}

#WxcColor .el-button--text{
  color: #43753d;
}
.noticealert {
  position: absolute;
  right: 16px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FF3636;
}

.group-leftbar .left-menu {
  border: 1px solid #9e9e9e38
}

.group-leftbar .el-radio__label, .group-leftbar .el-input__inner, .group-leftbar .el-textarea__inner {
  font-size: 17px;
}

.double-check {
  width: 200px
}

.group-leftbar ::placeholder {
  color: #7f838b;
  opacity: 1; /* Firefox */
}

.group-leftbar ul {
  list-style: none;
  padding-left: 0;
}

.menu-group {
  padding-left: 5px;
  padding-right: 5px;
}

.group-leftbar .el-input input {
  border-radius: 5px !important;
}

.group-leftbar li {
  /*padding: 10px;*/
  position: relative;
  /*border-bottom: 1px solid #f0f0f0;*/
  cursor: pointer;
  font-size: 19px;
  color: #425466
}

.group-leftbar .cattitle {
  background-color: #f6f6f6;
  font-size: 19px;
  padding: 10px 0 15px;
  color: #343a40;
  font-weight: 600;
}

li.left-bar-title i {
  font-size: 29px;
}

li.left-bar-title {
  display: flex;
  vertical-align: middle;
  padding: 15px 20px;

}

.el-button.is-round.explain {
  outline: none;
  border-radius: 50%;
  padding: 7px;
  border: 0;
}

.el-button.is-round:hover {
  background-color: rgba(60, 64, 67, 0.078);

}

.group-leftbar svg.text-primary.lable {
  position: absolute;
  margin-left: 25px;
  margin-top: -46px;
  transform: rotate(34deg)
}

.mobile-avatar {
  margin: 0;
  height: 60px;
  box-shadow: -8px 0px 5px -5px #ececec inset;
}

.mobile-avatar svg {
  margin-left: -18px;
  margin-top: -86px;
  transform: rotate(34deg)
}

.group-leftbar li.active, .group-leftbar li:hover {
  background-color: aliceblue;
  color: #028cca;
}

.is-plain {
  color: #02a1dc;
  background: #ffffff;
}

.group-leftbar .register-group li {
  padding: 0;
}


.group-leftbar .register-group li:hover {
  background-color: #fff;
}

sticky-top {
  position: sticky;
  top: 10px;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.sidebar-sticky {
  height: calc(100vh);
  overflow-x: hidden;
  overflow-y: auto;
}

.group-add.el-button.is-plain {
  /*border-color: $primary-color;*/
  font-size: 18px !important;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #ced0d4 #ced0d4;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 15px;
  /*height: 10px;*/
}

*::-webkit-scrollbar-track {
  background: #fff;
}

*::-webkit-scrollbar-thumb {
  background-color: #f6f6f6;
  border-radius: 20px;
  border: 15px solid #a7abaf;
}
@media (max-width: 575.98px) {
  .group-leftbar li.active, .group-leftbar li:hover {
    background-color:aliceblue ;
    color: #028cca;
    border-radius: 5px;
  }
}
</style>
<style>
#WxcColor .group-leftbar .mygrouplist{
  margin:0
}
#WxcColor  .el-button--primary {
  color: #FFF;
  background-color: #43753d;
  border-color: #43753d;
}
.group-leftbar .mygrouplist{
  margin:0 5px
}
.noticealert {
  position: absolute;
  right: 16px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FF3636;
}

.group-leftbar .left-menu {
  border: 1px solid #9e9e9e38
}

.group-leftbar .el-radio__label, .group-leftbar .el-input__inner, .group-leftbar .el-textarea__inner {
  font-size: 17px;
}

.double-check {
  width: 200px
}

.group-leftbar ::placeholder {
  color: #7f838b;
  opacity: 1; /* Firefox */
}

.group-leftbar ul {
  list-style: none;
  padding-left: 0;
}

.menu-group {
  padding-left: 5px;
  padding-right: 5px;
}

.group-leftbar .el-input input {
  border-radius: 5px !important;
}

.group-leftbar li {
  /*padding: 10px;*/
  position: relative;
  /*border-bottom: 1px solid #f0f0f0;*/
  cursor: pointer;
  font-size: 19px;
  color: #425466
}

.group-leftbar .cattitle {
  background-color: #f6f6f6;
  font-size: 19px;
  padding: 10px 0 15px;
  color: #343a40;
  font-weight: 600;
}

li.left-bar-title i {
  font-size: 29px;
}

li.left-bar-title {
  display: flex;
  vertical-align: middle;
  padding: 15px 20px;

}

.el-button.is-round.explain {
  outline: none;
  border-radius: 50%;
  padding: 7px;
  border: 0;
}

.el-button.is-round:hover {
  background-color: rgba(60, 64, 67, 0.078);

}

.group-leftbar svg.text-primary.lable {
  position: absolute;
  margin-left: 25px;
  margin-top: -46px;
  transform: rotate(34deg)
}

.mobile-avatar {
  margin: 0;
  height: 60px;
  box-shadow: -8px 0px 5px -5px #ececec inset;
}

.mobile-avatar svg {
  margin-left: -18px;
  margin-top: -86px;
  transform: rotate(34deg)
}

.group-leftbar li.active, .group-leftbar li:hover {
  background-color: aliceblue;
  color: #028cca;
}

.is-plain {
  color: #02a1dc;
  background: #ffffff;
}

.group-leftbar .register-group li {
  padding: 0;
}


.group-leftbar .register-group li:hover {
  background-color: #fff;
}

sticky-top {
  position: sticky;
  top: 10px;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.sidebar-sticky {
  height: calc(100vh);
  overflow-x: hidden;
  overflow-y: auto;
}

.group-add.el-button.is-plain {
  /*border-color: $primary-color;*/
  font-size: 18px !important;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #ced0d4 #ced0d4;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 15px;
  /*height: 10px;*/
}

*::-webkit-scrollbar-track {
  background: #fff;
}

*::-webkit-scrollbar-thumb {
  background-color: #f6f6f6;
  border-radius: 20px;
  border: 15px solid #a7abaf;
}
@media (max-width: 575.98px) {
  .group-leftbar li.active, .group-leftbar li:hover {
    background-color:aliceblue ;
    color: #028cca;
    border-radius: 5px;
  }
}
</style>